"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema = {
    type: "object",
    properties: {
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
};
exports.default = schema;
